import { Link } from 'react-router';

import useStyles from './AnchorWrapper.styles';

const AnchorWrapper = ({
  children,
  colorAnchor,
  itemId,
  path
}: {
  children: React.ReactNode;
  colorAnchor?: boolean;
  itemId?: number | string | null;
  path?: string;
}) => {
  const { classes } = useStyles({ colorAnchor });

  const pathname = path || `/ticket`;

  return (
    <Link className={classes.link} to={`${pathname}/${itemId}`}>
      {children}
    </Link>
  );
};

export default AnchorWrapper;
